import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../store/reducer';
import './ProductSelector.scss';
import { showLoadingAndRun } from 'store/popup/actions';
import SelectorItem from 'components/SelectorItem';
import { t } from 'helpers/i18n';
import { Product } from 'data/terra/Product';
import { selectProduct } from 'containers/store/productSelector/actions/SelectProduct';

const ProductSelector: React.FunctionComponent = () => {
  const dispatch = useDispatch();
  const { products, selectedProduct } = useSelector(
    (state: RootState) => state.productSelector
  );
  const sortedProducts = [...products].sort((a: Product, b: Product) =>
    a.name.localeCompare(b.name)
  );

  const onProductSelect = (value: string) => {
    dispatch(showLoadingAndRun(selectProduct(value)));
  };

  return (
    <div className="selector-header-container">
      <div className="product-selector-container">
        <SelectorItem
          label={t('Select Product')}
          value={selectedProduct?.name}
          onChange={onProductSelect}
          options={sortedProducts.map((p: Product) => ({
            key: p.id,
            value: p.name,
          }))}
          uiMode="horizontal"
          marginRight={true}
        />
      </div>
    </div>
  );
};

export default ProductSelector;
